export default {
  section_title: 'Moeda',
  label: 'Moeda',
  tooltip:
    'A moeda utilizada nos seus preços, pagamentos e relatórios. É definida para a sua conta de parceiro quando esta é criada e não pode ser alterada aqui — contacte o suporte se estiver incorreta.',
  from_your_partner: 'Do seu parceiro',
  set_for_your_account: 'Definida para a sua conta',
};
